import { render } from "./WailitHistory.vue?vue&type=template&id=4e2fdd9f&scoped=true"
import script from "./WailitHistory.vue?vue&type=script&lang=js"
export * from "./WailitHistory.vue?vue&type=script&lang=js"

import "./WailitHistory.vue?vue&type=style&index=0&id=4e2fdd9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2fdd9f"]])

export default __exports__